import { Type } from "@angular/core";
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";

// DIALOG INTERFACES
export interface StandardDialogData {
  iconName?: string;
  title?: string;
  content?: string;
  primaryActionButtonText?: string;
  secondaryActionButtonText?: string;
  handleClickPrimaryButton?: () => void;
  handleClickSecondaryButton?: () => void;
}

export interface DialogConfig<T, D = unknown> {
  component: Type<T>;
  data?: D;
  panelClass?: string;
  enterAnimationDuration?: string;
  exitAnimationDuration?: string;
}

export interface MatDialogDetailsData {
  id: number;
  type: string;
  fromPointPlannerCustomRouteDesktop?: boolean;
}

export interface BottomSheetConfig<T, D = unknown> {
  component: Type<T>;
  data?: D;
  panelClass?: string;
}

export enum BottomSheetLevel {
  CLOSED = 0,
  MINIMIZED = 1,
  MEDIUM = 2,
  EXPANDED = 3,
};

// SNACKBAR INTERFACES
export interface MatSnackbarData {
  message: string;
  iconName?: string;
}
export interface MatSnackbarConfig<T> {
  component: Type<T>;
  data?: MatSnackbarData;
  panelClass?: string;
  duration?: number; // Duration in milliseconds
  horizontalPosition?: MatSnackBarHorizontalPosition;
  verticalPosition?: MatSnackBarVerticalPosition
}
  